









import {Prop} from 'vue-property-decorator';
import {Component, Vue} from '@/shared/component';

import storeLongueursAchat from '@/stores/modules/longueursAchat';
import InputGenericEntitySelect from './GenericEntitySelect.vue';

@Component({
	components: {
		InputGenericEntitySelect
	}
})
export default class InputLongueursAchat extends Vue {

	@Prop ({ type: Function, required: false, default: () => ( () => true ) }) private itemFilter!: () => boolean;
	
	store = storeLongueursAchat;
}
